import api from "PFCore/api";
import { Collection, Id } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type NextAvailability = {
  profileId: Id;
  daysCount: number;
  startDate: string;
  endDate: string;
};

export type NextAvailabilitiesResponse = Collection<NextAvailability[]>;

export const fetchMarketplaceNextAvailabilities = (params: QueryParams) =>
  api<NextAvailabilitiesResponse>({
    url: "marketplace/next_availabilities",
    params
  });
